export const aboutMeEN = {
  title: "Senior Software Engineer",
  cover: [
    "Hi! I’m a Senior Software Engineer with 9+ years of experience, mostly focused on web development and leading technical teams.",
    "My aim is to enhance user experience and create meaningful value by staying closely connected with end users, while delivering clean, scalable code. I build strong, genuine relationships with my team and support their growth and development. I am a self-learner, open-minded about tools and technology stacks, and always ready for new challenges.",
  ],
  info: [
    "Education: Computer Engineering (Associate)",
    "Location: Berlin, Germany",
    "Marriage: Single",
    "Birth Date: 22 Feb 1996",
  ],
};
